// Tag service for API calls to backend functions

const API_BASE = process.env.REACT_APP_API_BASE;

// Get all tags
export const getAllTags = async () => {
  try {
    const response = await fetch(`${API_BASE}/tag/get`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const tags = await response.json();
    return Array.isArray(tags) ? tags : [];
  } catch (error) {
    console.error('Error getting tags:', error);
    return []; // Return empty array on error to prevent crashes
  }
};

// Get tags by category
export const getTagsByCategory = async (category) => {
  try {
    const response = await fetch(`${API_BASE}/tag/get?category=${encodeURIComponent(category)}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const tags = await response.json();
    return Array.isArray(tags) ? tags : [];
  } catch (error) {
    console.error('Error getting tags by category:', error);
    return [];
  }
};

// Get active tags - FIXED VERSION
export const getActiveTags = async () => {
  try {
    console.log('Loading active tags...');
    const response = await fetch(`${API_BASE}/tag/get?isActive=true`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const tags = await response.json();
    console.log('Tags loaded:', tags);
    return Array.isArray(tags) ? tags : [];
  } catch (error) {
    console.error('Error getting active tags:', error);
    return [];
  }
};

// Get tag by ID
export const getTagById = async (tagId) => {
  try {
    const response = await fetch(`${API_BASE}/tag/get?id=${encodeURIComponent(tagId)}`);
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const tag = await response.json();
    return tag;
  } catch (error) {
    console.error('Error getting tag by ID:', error);
    return null;
  }
};

// Create a new tag
export const createTag = async (tagData) => {
  try {
    const response = await fetch(`${API_BASE}/tag/post`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: tagData.name,
        category: tagData.category || 'general',
        color: tagData.color || TAG_COLORS[Math.floor(Math.random() * TAG_COLORS.length)],
        isActive: tagData.isActive !== false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const newTag = await response.json();
    return newTag;
  } catch (error) {
    console.error('Error creating tag:', error);
    throw error;
  }
};

// Update a tag
export const updateTag = async (tagId, updates) => {
  try {
    const response = await fetch(`${API_BASE}/tag/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: tagId,
        ...updates,
        updatedAt: new Date().toISOString()
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const updatedTag = await response.json();
    return updatedTag;
  } catch (error) {
    console.error('Error updating tag:', error);
    throw error;
  }
};

// Delete a tag
export const deleteTag = async (tagId) => {
  try {
    const response = await fetch(`${API_BASE}/tag/delete`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: tagId })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return true;
  } catch (error) {
    console.error('Error deleting tag:', error);
    throw error;
  }
};

// Soft delete a tag (set isActive to false)
export const deactivateTag = async (tagId) => {
  try {
    const response = await fetch(`${API_BASE}/tag/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: tagId,
        isActive: false,
        updatedAt: new Date().toISOString()
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return true;
  } catch (error) {
    console.error('Error deactivating tag:', error);
    throw error;
  }
};

// Default tag colors
export const TAG_COLORS = [
  '#e3f2fd', // Light Blue
  '#f3e5f5', // Light Purple
  '#e8f5e8', // Light Green
  '#fff3e0', // Light Orange
  '#ffebee', // Light Red
  '#f1f8e9', // Light Lime
  '#e0f2f1', // Light Teal
  '#fce4ec', // Light Pink
  '#f9fbe7', // Light Yellow Green
  '#e1f5fe'  // Light Cyan
];

// Ensure all exports are properly available
const tagService = {
  getAllTags,
  getTagsByCategory,
  getActiveTags,
  getTagById,
  createTag,
  updateTag,
  deleteTag,
  deactivateTag,
  TAG_COLORS
};

export default tagService;
